import { INVOICE_APIS } from "@/api_framework/api_config";
import { IIvoiceListResponse } from "@/api_framework/api_modals/Invoce";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setInvoice } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInvoiceListAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (shiftId: string) => {
      dispatch(
        setLoading({
          key: "isInvoiceInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(INVOICE_APIS?.INVOICE_LIST?.baseURL ?? "", {
            params: { user_id: shiftId, page_num: 1, limit: 10 },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IIvoiceListResponse>) => {
            if (res.data.status === true) {
              dispatch(setInvoice({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: "isInvoiceInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(
                setLoading({
                  key: "isInvoiceInProgress",
                  status: false,
                }),
              );
              dispatch(setInvoice({ data: [] }));
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            // toast("Invoice records not found");
            dispatch(
              setLoading({
                key: "isInvoiceInProgress",
                status: false,
              }),
            );
            dispatch(setInvoice({ data: [] }));
          });
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
